import React, { useState } from 'react';
import InfoTab from './tabelements/infotab/InfoTab';
import AccountStatus from './tabelements/statustab/AccountStatus';
import UserReminderTab from './tabelements/userstab/UserReminderTab';
import MediaTab from './tabelements/mediatab/MediaTab';
import ReminderTab from './tabelements/remindertab/ReminderTab';
import SettingsTab from './tabelements/featurestab/SettingsTab';
import LensTab from './tabelements/lensbrandtab/LensTab';
import UsersTab from './tabelements/userstab/UsersTab';
import TabContent from './TabContent';
import TabNavItem from './TabNavItem';
import ClinicUserAdd from './tabelements/userstab/ClinicUserAdd';
import ClinicUserSettings from './tabelements/userstab/ClinicUserSettings';
import CustomizationTab from './tabelements/customizationtab/CustomizationTab';
import SocialTab from './tabelements/socialtab/SocialTab';
import HistoryTab from './tabelements/historytab/HistoryTab';
import HoursOfOperation from './tabelements/hourstab/HoursOfOperation';
import ReputationTab from './tabelements/reputationtab/ReputationTab';
import BookingTab from './tabelements/bookingtab/BookingTab';
import StatsTab from './tabelements/statstab/StatsTab';
import SurveyTab from './tabelements/surveystab/SurveyTab';
import RecallsTab from './tabelements/recallstab/RecallsTab';
import SmsgatewayTab from './tabelements/smsgatewaytab/SmsgatewayTab';
import DocumentTab from './tabelements/documenttab/DocumentTab';
import './clinics-modules.css';
const NAV_GROUPS = [
    {
        label: 'Overview',
        items: [
            {
                id: 'clinic-info-tab',
                title: 'Info',
                icon: 'bi bi-info-circle',
                iconfill: 'bi bi-info-circle-fill',
            },
            {
                id: 'clinic-documents-tab',
                title: 'Documents',
                icon: 'bi bi-file-richtext',
                iconfill: 'bi bi-file-richtext-fill',
            },
            {
                id: 'clinic-status-tab',
                title: 'Account Status',
                icon: 'bi bi-clipboard2-pulse',
                iconfill: 'bi bi-clipboard2-pulse-fill',
            },
            {
                id: 'clinic-history-tab',
                title: 'History',
                icon: 'bi bi-clock-history',
                iconfill: 'bi bi-clock-history',
            },
        ],
    },
    {
        label: 'Operations',
        items: [
            {
                id: 'clinic-hour-tab',
                title: 'Hours of Operations',
                icon: 'bi bi-clock',
                iconfill: 'bi bi-clock-fill',
            },
            {
                id: 'clinic-booking-tab',
                title: 'Bookings',
                icon: 'bi bi-calendar3-range',
                iconfill: 'bi bi-calendar3-range-fill',
            },
            {
                id: 'clinic-reminder-tab',
                title: 'Reminder',
                icon: 'bi bi-alarm',
                iconfill: 'bi bi-alarm-fill',
            },
            {
                id: 'clinic-recalls-tab',
                title: 'Recalls',
                icon: 'bi bi-repeat',
                iconfill: 'bi bi-repeat',
            },
        ],
    },
    {
        label: 'Communications',
        items: [
            {
                id: 'clinic-sms-gateway',
                title: 'SMS Gateway',
                icon: 'bi bi-chat-text',
                iconfill: 'bi bi-chat-text-fill',
            },
            {
                id: 'clinic-reputation-tab',
                title: 'Reputation',
                icon: 'bi bi-star',
                iconfill: 'bi bi-star-fill',
            },
            {
                id: 'clinic-surveys-tab',
                title: 'Surveys',
                icon: 'bi bi-clipboard-data',
                iconfill: 'bi bi-clipboard-data-fill',
            },
        ],
    },
    {
        label: 'Configuration',
        items: [
            {
                id: 'clinic-users-tab',
                title: 'Users',
                icon: 'bi bi-people',
                iconfill: 'bi bi-people-fill',
            },
            {
                id: 'clinic-settings-tab',
                title: 'Features',
                icon: 'bi bi-gear',
                iconfill: 'bi bi-gear-fill',
            },
            {
                id: 'clinic-customization-tab',
                title: 'Customization',
                icon: 'bi bi-house-gear',
                iconfill: 'bi bi-house-gear-fill',
            },
            {
                id: 'clinic-lensbrand-tab',
                title: 'Lens Brand',
                icon: 'bi bi-eye',
                iconfill: 'bi bi-eye-fill',
            },
            {
                id: 'clinic-social-tab',
                title: 'Social Links',
                icon: 'bi bi-share',
                iconfill: 'bi bi-share-fill',
            },
        ],
    },
    {
        label: 'Media & Analytics',
        items: [
            {
                id: 'clinic-media-tab',
                title: 'Media',
                icon: 'bi bi-file-image',
                iconfill: 'bi bi-file-image-fill',
            },
            {
                id: 'clinic-stats-tab',
                title: 'Patient Stats',
                icon: 'bi bi-bar-chart',
                iconfill: 'bi bi-bar-chart-fill',
            },
        ],
    },
];

const ClinicTabContainer = () => {
    const [activeTab, setActiveTab] = useState('clinic-info-tab');

    return (
        <div className="clinic-detail-layout">
            <aside className="clinic-detail-sidebar" aria-label="Clinic sections">
                {NAV_GROUPS.map((group) => (
                    <div key={group.label} className="clinic-detail-nav-group">
                        <div className="clinic-detail-nav-group__label">{group.label}</div>
                        <ul className="clinic-detail-nav">
                            {group.items.map((item) => (
                                <TabNavItem
                                    key={item.id}
                                    id={item.id}
                                    title={item.title}
                                    icon={item.icon}
                                    iconfill={item.iconfill}
                                    activeTab={activeTab}
                                    setActiveTab={setActiveTab}
                                />
                            ))}
                        </ul>
                    </div>
                ))}
            </aside>

            <div className="clinic-detail-content">
                <TabContent id="clinic-info-tab" activeTab={activeTab}>
                    <InfoTab />
                </TabContent>
                <TabContent id="clinic-documents-tab" activeTab={activeTab}>
                    <DocumentTab />
                </TabContent>
                <TabContent id="clinic-status-tab" activeTab={activeTab}>
                    <AccountStatus />
                </TabContent>
                <TabContent id="clinic-sms-gateway" activeTab={activeTab}>
                    <SmsgatewayTab />
                </TabContent>
                <TabContent id="clinic-hour-tab" activeTab={activeTab}>
                    <HoursOfOperation />
                </TabContent>
                <TabContent id="clinic-social-tab" activeTab={activeTab}>
                    <SocialTab />
                </TabContent>
                <TabContent id="clinic-customization-tab" activeTab={activeTab}>
                    <CustomizationTab />
                </TabContent>
                <TabContent id="clinic-lensbrand-tab" activeTab={activeTab}>
                    <LensTab />
                </TabContent>
                <TabContent id="clinic-settings-tab" activeTab={activeTab}>
                    <SettingsTab />
                </TabContent>
                <TabContent id="clinic-reminder-tab" activeTab={activeTab}>
                    <ReminderTab />
                </TabContent>
                <TabContent id="clinic-booking-tab" activeTab={activeTab}>
                    <BookingTab />
                </TabContent>
                <TabContent id="clinic-reputation-tab" activeTab={activeTab}>
                    <ReputationTab />
                </TabContent>
                <TabContent id="clinic-users-tab" activeTab={activeTab}>
                    <UsersTab setActiveTab={setActiveTab} activeTab={activeTab} />
                </TabContent>
                <TabContent id="clinic-user-reminder" activeTab={activeTab}>
                    <UserReminderTab setActiveTab={setActiveTab} />
                </TabContent>
                <TabContent id="clinic-user-settings" activeTab={activeTab}>
                    <ClinicUserSettings setActiveTab={setActiveTab} />
                </TabContent>
                <TabContent id="clinic-user-add" activeTab={activeTab}>
                    <ClinicUserAdd setActiveTab={setActiveTab} />
                </TabContent>
                <TabContent id="clinic-surveys-tab" activeTab={activeTab}>
                    <SurveyTab />
                </TabContent>
                <TabContent id="clinic-recalls-tab" activeTab={activeTab}>
                    <RecallsTab />
                </TabContent>
                <TabContent id="clinic-media-tab" activeTab={activeTab}>
                    <MediaTab />
                </TabContent>
                <TabContent id="clinic-history-tab" activeTab={activeTab}>
                    <HistoryTab />
                </TabContent>
                <TabContent id="clinic-stats-tab" activeTab={activeTab}>
                    <StatsTab />
                </TabContent>
            </div>
        </div>
    );
};

export default ClinicTabContainer;
